import React, { useState, useEffect } from 'react';
import { client, urlFor } from '../sanityClient';
import SEO from '../components/SEO';
import ContactCTA from '../components/ContactCTA';
import './Flower.css';

function Flower() {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const query = '*[_type == "flower" && featured == true] | order(order asc)[0...5]';
    client.fetch(query).then(data => {
      setPartners(data);
      setLoading(false);
    }).catch(err => {
      console.error(err);
      setLoading(false);
    });
  }, []);

  return (
    <div className="flower-page">
      <SEO
        title="플라워 | Flower"
        description="가든포에트 웨딩 플라워 데코레이션. 제휴 플로리스트가 만드는 정원과 어울리는 자연스러운 플라워 스타일링."
        path="/flower"
      />
      <section className="flower-hero">
        <div className="container">
          <div className="hero-content fade-in">
            <h1 className="page-hero-title">FLOWER PARTNERS</h1>
            <p className="hero-subtitle">Curated by Garden Poète</p>
          </div>
        </div>
      </section>

      <section className="flower-intro">
        <div className="container">
          <div className="intro-content fade-in">
            <p>공간을 완성하는 것은 꽃입니다.</p>
            <p>
              소박하고 자연스러운 화이트&그린 플라워,<br />
              정원의 분위기를 살린 내추럴 가든 스타일,<br />
              특별한 순간을 위한 럭셔리 플라워.
            </p>
            <p>
              당신이 꿈꾸는 웨딩의 색으로<br />
              공간을 채워드립니다.
            </p>
            <p className="flower-notice">
              플라워 업체는 예식 일정에 따라 예약 가능 여부가 다릅니다.<br />
              예식 예약 전 업체와 먼저 일정을 조율해 주시길 권장드립니다.<br />
              소개된 업체는 Garden Poète의 추천이며, 자유롭게 다른 업체를 이용하셔도 됩니다.
            </p>
          </div>
        </div>
      </section>

      <section className="flower-section">
        <div className="container">
          {loading ? (
            <p className="loading-text">로딩중...</p>
          ) : partners.length > 0 ? (
            <div className="partners-list">
              {partners.map((partner, index) => (
                <div key={partner._id} className="partner-showcase fade-in">
                  {partner.images && partner.images.length > 0 && (
                    <div className="instagram-grid">
                      {partner.images
                        .filter(image => image && image.asset && image.asset._ref)
                        .map((image, imgIndex) => (
                          <div key={imgIndex} className="grid-item">
                            <img src={urlFor(image).width(400).url()} alt={`${partner.name} ${imgIndex + 1}`} />
                          </div>
                        ))}
                    </div>
                  )}

                  <div className="partner-content">
                    <h2>{partner.name}</h2>
                    {partner.specialty && <p className="partner-style">{partner.specialty}</p>}
                    {partner.description && <p className="partner-description">{partner.description}</p>}
                    
                    <div className="contact-info">
                      {partner.instagram && (
                        <p className="contact-item">
                          📷 {partner.instagramUrl ? (
                            <a href={partner.instagramUrl} target="_blank" rel="noopener noreferrer">
                              {partner.instagram}
                            </a>
                          ) : partner.instagram}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="no-partner fade-in">
              <h2>파트너 준비중</h2>
              <p>곧 Garden Poète가 신뢰하는 플라워 파트너를 소개해드립니다.</p>
            </div>
          )}
        </div>
      </section>

      <ContactCTA 
        title="맞춤 플라워 상담" 
        subtitle="당신만의 특별한 플라워 데코를 함께 만들어갑니다"
      />
    </div>
  );
}

export default Flower;
